import { useState } from "react";
import { SelectComponent } from "../components/SelectComponent";
import AnniversaryTemplateBuilder from "../components/ImageBuilder/AnniversaryTemplateBuilder";
import WelcomeTemplateBuilder from "../components/ImageBuilder/WelcomeImageBuilder";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { AppToolbar } from "../components/AppToolbar";
import { useTranslation } from "react-i18next";
import { Token } from "../theme";

const useStyles = makeStyles(
  () => ({
    container: {
      maxWidth: 1200,
    },
  }),
  { index: 1 },
);

export default function ImageTemplateBuilder() {
  const [selectedTemplate, setSelectedTemplate] = useState<string>("");
  const classes = useStyles();
  const handleOnSelect = (value: string) => {
    setSelectedTemplate(value);
  };
  const options = ["Welcome", "Anniversary"];
  const { t } = useTranslation();

  const renderBasedOnSelectedOption = () => {
    if (selectedTemplate.toLowerCase() === "welcome") {
      return <WelcomeTemplateBuilder />;
    }

    if (selectedTemplate.toLowerCase() === "anniversary") {
      return <AnniversaryTemplateBuilder />;
    }

    return <></>;
  };

  return (
    <Box className={classes.container}>
      <AppToolbar title={t("Image template builder")}></AppToolbar>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          borderRadius: "4px",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: "1rem",
          border: `${Token.borderDefault} solid 1px`,
          boxSizing: "inherit",
          width: "fit-content",
        }}
      >
        <SelectComponent
          label={"Select a template to edit"}
          value={selectedTemplate}
          options={options}
          setValue={handleOnSelect}
          size="medium"
          customStyle={{ minWidth: "200px" }}
        />
      </Box>
      {renderBasedOnSelectedOption()}
    </Box>
  );
}
